// eslint-disable-next-line no-shadow
export enum workflowKeys {
  approve = "APPROVE",
  refer_back = "REFER_BACK",
  publish = "Publish",
  draft = "draft",
  request_review = "request_review",
  admin = "admin",
  published = "published",
  completed = "Completed",
  accepted = "accepted",
  publisher = "publisher",
}
